import StandardOverview from '@rebuild/materials/shared/quote/standard/TmplOverview.vue';

export const componentMap = {
	overview: StandardOverview
};
